import { render, staticRenderFns } from "./IT_Page.vue?vue&type=template&id=6409cd5f&"
import script from "./IT_Page.vue?vue&type=script&lang=js&"
export * from "./IT_Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports